import { CSSProperties, ReactNode } from 'react';
import styles from './notification-row.module.css';

export const NOTIFICATION_ROW_DIVIDER_STYLE = {
  '--bs-border-color': 'var(--bs-primary-200)',
} as CSSProperties;

export default function NotificationRow({
  children,
  onClick,
  className = '',
  style,
}: {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`d-flex align-items-center justify-content-between px-3 py-2 border-bottom ${styles.row} ${onClick ? styles.rowClickable : ''} ${className}`}
      style={style}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
